/* smartlabel.js */
'use strict';

$(function() {

// multiModal

var $multiModal = $('#multiModal');
var modalRedirectUrl;
$multiModal.on('show.bs.modal', function(e) {
  var triggeredBy = e.relatedTarget;
  modalRedirectUrl = (triggeredBy) ? triggeredBy.dataset.url : '';
  var modalBody = document.querySelector('#multiModal .modal-body');
  if (triggeredBy.classList.contains('smartlabel')) {
    modalBody.querySelector('.default').classList.add('hidden');
    modalBody.querySelector('.smartlabel').classList.remove('hidden');
  } else {
    modalBody.querySelector('.default').classList.remove('hidden');
    modalBody.querySelector('.smartlabel').classList.add('hidden');
  }
  // console.info('#multiModal url = %s', modalRedirectUrl);
});
$('.clickRedirect').on('click', function() {
  $multiModal.modal('hide');
  if (modalRedirectUrl) {
    window.location.href = modalRedirectUrl;
  }
});

// code date modal
// $('#code-date-button').on('click', function(e) {
//   e.preventDefault();
//   $('#code-date-modal').modal('toogle');
//   return false;
// });

// tooltips

$('[data-tooltip=\'true\']').tooltip({
  container: 'body'
});

// upc expand toggle
$('.upc-expand-target')
.on('show.bs.collapse', function()  {
  $('.upc-expander').html('less&hellip;<i class="fas fa-caret-up"></i>');
})
.on('hide.bs.collapse', function() {
  $('.upc-expander').html('more&hellip;<i class="fas fa-caret-down"></i>');
});

// accordion scroll

$('.accParent').on('shown.bs.collapse', function(){
  // define width of the window as variable (for later use in mobile viewports)
  var winW = $(window).width();
  // define nearest card object in the DOM (this is the .card that is about to be clicked open into display)
  var $card = $(this).closest('.card.card-blue');
  // define scroll-offset: adjust height px value to account for content at top of card (including masthead/title-bar if they exist)
  var offsetPX = 0; // when set to zero ('0'), the offset will animate the opened accordion .card div to the top of the viewport
  // logic for changing offset value in mobile display if necessary due to height of page elements in mobile rendering
  if(winW <= 767){
    offsetPX = 0; // when set to zero ('0'), the offset will animate the opened accordion .card div flush to the top of the viewport
  }
  // animate the scroll behavior to height of offset pixel value, duration 1s
  $('html,body').animate({
    scrollTop: $card.offset().top + offsetPX
  }, 250);
});
// prevent event capturing (bubbling DOWN throught he DOM from parent accordion to nested children accordions)
$('.accChild').on('shown.bs.collapse', function(e){
  e.stopPropagation();
});

/*
  tab ids: "ingredients", "advisories", "usage", "features", "brand"
*/
// show appropriate tab on load
(function( hash ) {
  if( typeof hash === 'undefined'
    || ['#ingredients', '#advisories', '#usage', '#features', '#brand'].indexOf(hash) === -1) return;
  var tabId = '#tab-' + hash.slice(1);
  $(tabId).tab('show');
})(window.location.hash);
// update url hash when tab is changed
$('a[data-toggle=tab]').on('shown.bs.tab', function(e) {
  var hash = $(e.target).attr('href');
  if (hash) history.pushState(null, null, hash);
});

//SmartLabel Certification Logo Links in page-head control
$('.certLogoLink').on('click', function(event){
  event.preventDefault();
  $('[data-toggle="tab"][href="' + this.hash + '"]').trigger('click');
  $('#collapse2').collapse('show');
})

;(function(btn){
  if (!btn) return;

  // console.info('history.length =', history.length, 'document.referrer =', document.referrer, 'window.opener =', window.opener);
  var initialHistoryLength = history.length; // save starting history length due to in page links i.e. #features
  var canGoBack = (initialHistoryLength > 1)
        || (document.referrer && window.opener);
  if (!canGoBack) {
    btn.classList.add('btn-back-disabled');
    btn.setAttribute('disabled','');
  }
  
  btn.addEventListener('click', function(event) {
    event.preventDefault();
    if (initialHistoryLength === 1 && document.referrer && window.opener) {
      window.opener.focus();
      window.close();
    } else if (initialHistoryLength > 1) {
      history.back();
    }
    return false;
  });

})(document.getElementById('button-back'));

}); // document.ready
